import { io } from 'socket.io-client'
import { REST_API, REST_API_IO } from 'src/constants/DefaultValues'

function getChatSocketTarget() {
  const restApi = String(REST_API || REST_API_IO || '').trim()
  try {
    const url = new URL(restApi)
    const basePath = url.pathname.replace(/\/$/, '')
    const path =
      basePath && basePath !== '/'
        ? `${basePath}/socket.io`
        : '/socket.io'
    return { origin: url.origin, path }
  } catch (e) {
    return { origin: restApi.replace(/\/$/, ''), path: '/socket.io' }
  }
}

function isLocalSocketOrigin(origin) {
  return /localhost|127\.0\.0\.1/i.test(String(origin || ''))
}

const noop = () => {}

export function createNoopSocket() {
  return {
    on: noop,
    off: noop,
    once: noop,
    emit: noop,
    disconnect: noop,
    connect: noop,
    removeListener: noop,
    removeAllListeners: noop,
    connected: false,
    disconnected: true,
    id: null,
  }
}

let sharedChatSocket = null
let sharedChatSocketKey = ''

/** One shared chat socket per page — avoids session 400s from multiple connect/disconnect cycles. */
export function createChatSocket(options = {}) {
  const { origin, path } = getChatSocketTarget()
  if (!origin) {
    return createNoopSocket()
  }

  const key = `${origin}|${path}`
  if (sharedChatSocket && sharedChatSocketKey === key) {
    return sharedChatSocket
  }

  if (sharedChatSocket) {
    sharedChatSocket.removeAllListeners()
    sharedChatSocket.disconnect()
    sharedChatSocket = null
  }

  sharedChatSocket = io(origin, {
    path,
    transports: ['polling', 'websocket'],
    upgrade: true,
    rememberUpgrade: true,
    // Live is same-origin; local dev is cross-port — credentials break with CORS origin "*".
    withCredentials: !isLocalSocketOrigin(origin),
    secure: String(origin).startsWith('https://'),
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    ...options,
  })
  sharedChatSocketKey = key
  return sharedChatSocket
}
